'use client';

import { Box, freddyTheme, Loader } from '@coolblue-development/freddy';
import React, { ReactNode } from 'react';

import { useFiltersContext } from '../Context/useFiltersContext';

type Props = {
  children: ReactNode;
};

export const PendingWrapper = ({ children }: Props) => {
  const { isPending } = useFiltersContext();

  return (
    <Box
      sx={{
        position: 'relative',
        pointerEvents: isPending ? 'none' : 'auto',
        userSelect: isPending ? 'none' : 'auto'
      }}
    >
      {isPending && (
        <Box
          sx={{
            position: 'sticky',
            top: '50vh',
            zIndex: 1,
            // offset for the animated loader element
            '[role="status"]': {
              top: freddyTheme.spacing[600],
              [freddyTheme.breakpoint.minWidth('md')]: {
                marginLeft: '-2.9rem'
              }
            }
          }}
        >
          <Loader />
        </Box>
      )}

      <Box
        sx={{
          transition: `opacity ${freddyTheme.motionDuration.slow} ${freddyTheme.motionEasing.easeInOut}`,
          opacity: isPending ? 0.2 : 1
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
